import { CapitalActionEntryType } from 'further-types/lp/capital-action';
import { CapitalActionNoticeCreatorData } from './types';
import { ApiResponses } from 'lib/trpcClient';

export const mapResponseToCapitalActionNoticeCreatorData = (
  input: ApiResponses['capitalActionNotice']['get'],
): CapitalActionNoticeCreatorData => {
  const {
    generalCapitalBreakdown,
    notificationPreferences,
    perInvestorNotificationSettings,
    transactionOverview,
    perInvestorBreakdown,
  } = input;

  const generalCapitalCallTransactionEntry =
    transactionOverview.transactionEntries.find(
      (entry) => entry.entryType === CapitalActionEntryType.GeneralCapitalCall,
    );

  const notifyViaEmail = notificationPreferences?.notifyViaEmail ?? true;

  return {
    id: input.id,
    vehicleId: input.vehicleId,
    capitalActionId: input.capitalActionId,
    capitalActionName: input.capitalActionName,
    capitalActionDueDate: input.capitalActionDueDate,
    currencyLcy: input.currencyLcy,
    lcyRecipientBankAccountId: input.lcyRecipientBankAccountId,
    status: input.status,
    noticeDate: input.noticeDate,
    mainContactEmails: input.mainContactEmails,
    noticeNarrative: input.noticeNarrative,
    generalCapitalBreakdown: {
      valueLcy: generalCapitalCallTransactionEntry?.totalAmountLcy ?? 0,
      investmentsPercentage: generalCapitalBreakdown?.investmentsPercentage,
      investmentsAmount: generalCapitalBreakdown?.investmentsAmount,
      managementFeesPercentage:
        generalCapitalBreakdown?.managementFeesPercentage,
      managementFeesAmount: generalCapitalBreakdown?.managementFeesAmount,
      otherExpensesPercentage: generalCapitalBreakdown?.otherExpensesPercentage,
      otherExpensesAmount: generalCapitalBreakdown?.otherExpensesAmount,
    },
    notificationPreferences: {
      notifyViaEmail,
      attachPdfNoticeToEmail:
        notificationPreferences?.attachPdfNoticeToEmail ?? true,
      sendReminderEmails: Boolean(notificationPreferences?.sendReminderEmails),
      reminderEmailFrequencyInDays:
        notificationPreferences?.reminderEmailFrequencyInDays,
    },
    perInvestorNotificationSettings: perInvestorNotificationSettings.map(
      (setting) => ({
        investorId: setting.investorId,
        notifyViaEmail: setting.notifyViaEmail ?? notifyViaEmail,
        sendReminderEmails: setting.sendReminderEmails,
      }),
    ),
    transactionOverview: {
      totalCapitalCalledLcy: transactionOverview.totalCapitalCalledLcy,
      transactionEntries: transactionOverview.transactionEntries.map(
        (entry) => ({
          id: entry.id,
          entryType: entry.entryType,
          totalAmountLcy: entry.totalAmountLcy,
          counterparties: entry.counterparties.map((counterparty) => ({
            amountLcy: counterparty.amountLcy,
            counterpartyLabel: counterparty.counterpartyLabel,
          })),
        }),
      ),
    },
    perInvestorBreakdown: perInvestorBreakdown.map((entry) => ({
      id: entry.id,
      investorName: entry.investorName,
      capitalCalledLcy: entry.capitalCalledLcy,
      capitalDistributedLcy: entry.capitalDistributedLcy,
      totalDueLcy: entry.totalDueLcy,
      unfundedCommitmentLcy: entry.unfundedCommitmentLcy,
      unfundedCommitmentPercentage: entry.unfundedCommitmentPercentage,
    })),
  };
};
